
<div class="col-12 mt-2">
  <div class="col-12 flex border border-info rounded " #topDiv>
    <div class="col-3">
      <button pButton icon="fa fa-refresh" label="Refresh" class="buttonsRound noHover shadow"
        (click)="refreshBatchesForLabPlanning()"></button>
    </div>
    <div class="col-6 flex justify-content-end">
      <button pButton icon="fa fa-plus" label="Plan Tag Plate" class="buttonsRound noHover float-right shadow"
        (click)="updatePlannedTagPlate()" style="width: 25%;" [disabled]="disablePlanTagPlate()"></button>
    </div>
    <div class="col-3">
      <button pButton label="Export" icon="fa fa-download" class="buttonsRound noHover float-left shadow"
        [disabled]="!(batches && batches.length != 0)" (click)="exportBatchesToExcel()"></button>
    </div>
  </div>
  <div class="col-12 flex"   [style.height.px]="divHeight">
    <p-table #dt [loading]="loading" [value]="batches" selectionMode="multiple"  [style]="{'overflow':'visible', 'word-wrap': 'break-word'}" [columns]="scrollableCols" [loading]="loading" (onRowSelect)="addToSelectedRows($event)" (onRowUnselect)="removeFromSelectedMap($event)">
      <ng-template pTemplate="caption" style="height: 3rem;">
        <div class="flex justify-content-end" >
            <em class="fa fa-search" style="margin:4px 4px 0 0"></em>
            <input class="p-1" type="text" pInputText size="50" placeholder="Global Filter" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
        </div>
    </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr >
          <th scope="col" *ngFor="let col of columns" class="text-center" style="min-width: 10rem;" >
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-batch let-columns="columns">
        <tr [pSelectableRow]="batch">
          <ng-container *ngFor="let col of columns">
            <td *ngIf="(col.field != 'tagPlateId') || (col.field == 'tagPlateId' && batch[col.field] != null)" style="width: 10rem;height: 2.6rem;" class="text-center" [ngClass] = "{'completePuid': getCompletePUIDStyle(col, batch[col.field], batch['batchID']), 'redCell':isDuplicateTagPlate(batch[col.field], col, batch['batchID']), 'inProcess':isProcessInProgress(col.field, batch)}">
              {{ getTextCellValue(col.field, batch) }}
            </td>
            <td *ngIf="col.field == 'tagPlateId' && batch[col.field] == null && !invalidTags.includes(batch['plannedTagPlate'])" style="width: 10rem;height: 2.6rem;" [ngClass] = "{'redCell':isDuplicateTagPlate(batch['plannedTagPlate'], col, batch['batchID'])}">
              <p-dropdown  appendTo="body" placeholder="Plan Tag Plate" [style]="{'min-width':'100%','max-width':'100%'}" [options]="tags" [(ngModel)]="batch['plannedTagPlate']"  [showClear]="true" (onChange)="addTagPlateForPlanning(batch, $event)"
             ></p-dropdown>
            </td>
            <td *ngIf="col.field == 'tagPlateId' && batch[col.field] == null && invalidTags.includes(batch['plannedTagPlate'])" style="width: 10rem;height: 2.6rem;" [ngClass] = "{'redCell':isDuplicateTagPlate(batch['plannedTagPlate'], col, batch['batchID'])}">
              <p-dropdown  appendTo="body" placeholder="Plan Tag Plate" [style]="{'min-width':'100%','max-width':'100%'}" [options]="tagArrWithinactiveTags" [(ngModel)]="batch['plannedTagPlate']"  [showClear]="true" (onChange)="addTagPlateForPlanning(batch, $event)"
             ></p-dropdown>
            </td>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="19" class="text-center">
            No records found
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-blockUI [blocked]="blocked">
  <div>
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>
